import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVoorschotStookkostenWijzigen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#A8D3AF"
      d="M24.03 16.02c3.97 3.97 4.92 9.83 1.7 13.04-3.21 3.21-9.04 2.6-13.01-1.37l11.3-11.67z"
    />
    <path
      fill="#00A75D"
      d="M13.01 15.68s-1.02 3.43 2.41 5.72c0 0-3.43-11.44 5.72-16.01 0 0-2.29 3.43 1.14 6.86 3.96 3.96 9.43 6.39 7.67 14.31-.6 2.72-2.4 5.07-4.91 6.25-7.81 3.66-15.34-1.79-15.34-9.12 0 0 .13-5.7 3.3-8.01zm5.09 11.18c-1.02.77-2.31 1.4-3.84 1.49 2.1 2.38 5.69 3.42 9.31 1.64 1.01-.5 2.29-1.73 2.81-2.73 2.19-4.27.44-8.52-2.83-10.37.61 1.09.97 2.34.97 3.68 0 3.08-1.86 5.72-4.51 6.87-.12.05 1.87-1.58.89-5.04-.73 2.4-1.44 3.43-2.8 4.46"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVoorschotStookkostenWijzigen);

export default ForwardRef;
